import { render, staticRenderFns } from "./RVModificationTable.vue?vue&type=template&id=4db3b20c&scoped=true"
import script from "./RVModificationTable.vue?vue&type=script&lang=js"
export * from "./RVModificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3b20c",
  null
  
)

export default component.exports